import { metaContent } from "./meta_content";

export function initGlobalUi() {
  $("#version-icon").dblclick(function () {
    $('[data-toggle="tooltip"]').tooltip("dispose");
    $(this).html(
      '<i class="fas fa-alien" data-toggle="tooltip" title="GET SLOPED"></i> v' +
        metaContent("app-version")
    );
    $('[data-toggle="tooltip"]').tooltip();
  });

  // For bootstrap 4 layout

  $("#sidebar").mCustomScrollbar({
    theme: "minimal",
  });

  $("#sidebarCollapse").on("click", function () {
    $("#sidebar, #content").toggleClass("active");
    $(".collapse.in").toggleClass("in");
    $(".sidebar-collapse-toggle[aria-expanded=true]").attr("aria-expanded", "false");
  });

  // gogo datepickers
  $.extend($.fn.datepicker.defaults, {
    orientation: "auto auto",
    todayHighlight: true,
    format: "dd-M-yyyy",
    assumeNearbyYear: true,
  });

  $(".datepicker:not(.datepicker-inline)").datepicker();

  // gogo timepickers
  $(".timepicker").timepicker({
    showMeridian: false,
    showSeconds: true,
    minuteStep: 10,
    secondStep: 10,
    icons: {
      up: "fas fa-chevron-up",
      down: "fas fa-chevron-down",
    },
  });

  // in place editing
  $(".best_in_place").best_in_place();

  // bootstrap tooptips

  // applies a window boundary to dropdown items with tooltips to circumvent a known issue with PopperJS
  // that prevents tooltips from working inside elements with an overflow rule defined.
  $(".dropdown-item[data-toggle='tooltip']").attr("data-boundary", "window");

  $('[data-toggle="tooltip"]').tooltip({
    trigger: 'hover',
  });

  const updatedAllowList = structuredClone($.fn.popover.Constructor.Default.whiteList);
  updatedAllowList.table = [];
  updatedAllowList.thead = [];
  updatedAllowList.tbody = [];
  updatedAllowList.tr = [];
  updatedAllowList.th = [];
  updatedAllowList.td = [];

  $('[data-toggle="popover"]').popover({
    whiteList: updatedAllowList,
  });

  $('[data-toggle="tooltip"]').on('click', function () {
    $(this).tooltip('hide')
  });

  // enable range select
  $(".multi-select").checkboxes("range", true);

  // BOOTSTRAP INPUT SPINNER - CREATES + AND - BUTTONS TO THE RIGHT OF NUMBER INPUTS
  $("input[type='number']").not('.no-input-spinner').not('stimulus-spinner').inputSpinner();

  // disable increasing and decreasing the number input value on scroll
  $('input[type=number]').on('mousewheel', function(e) {
    $(e.target).blur();
  });

  /* Initialize quick nav select */
  $(".selectpicker").each(function (i, el) {
    if (!$(el).parent().hasClass("bootstrap-select")) {
      $(el).selectpicker("refresh");
    }
  });

  // force numeric entry
  $(".numeric").inputFilter(function (value) {
    return /^\d*$/.test(value);
  });

  $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
    if (!$(this).next().hasClass('show')) {
      $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
    }
    var $subMenu = $(this).next('.dropdown-menu');
    $subMenu.toggleClass('show');

    $(this).parents('.dropdown.show').on('hidden.bs.dropdown', function(e) {
      $('.dropdown-submenu .show').removeClass('show');
    });

    return false;
  });

  $("form input[type=submit]").click(function () {
    $("input[type=submit]", $(this).parents("form")).removeAttr("clicked");
    $(this).attr("clicked", "true");
  });

  // .side-scroll
  $(".side-scroll").each(function(i, element){
    element.addEventListener('wheel', function(ev){
      if (element.clientWidth < element.scrollWidth) {
        ev.preventDefault();
        element.scrollLeft += (ev.deltaY + ev.deltaX);
      }
    });
  })
}

// Split from initGlobalUi so main.js can run it last: React components must
// mount after every other turbo:load handler has registered.
export function mountGlobalComponents() {
  $(".modal.auto-open").modal("show");

  ReactRailsUJS.mountComponents();
}
